import React from 'react';
import { ReviewRating } from '../../../components';
import css from './Section.module.css';

const testimonials = [
  {
    id: 'fallback-birthday-dinner',
    displayName: 'Sarah L.',
    content:
      'Our private chef created a beautiful three-course dinner for my birthday celebration. The food was incredible and the kitchen was spotless afterward.',
    rating: 5,
    eventType: 'Birthday Dinner',
  },
  {
    id: 'fallback-family-gathering',
    displayName: 'Mark D.',
    content:
      'The chef worked with our dietary restrictions and created a menu everyone loved. It made hosting so much easier.',
    rating: 5,
    eventType: 'Family Gathering',
  },
  {
    id: 'fallback-anniversary-dinner',
    displayName: 'Jessica P.',
    content:
      'It truly felt like a restaurant experience in our home. The chef explained every course and the presentation was stunning.',
    rating: 5,
    eventType: 'Anniversary Dinner',
  },
];

function SectionTestimonials(props) {
  const { intl } = props;

  return (
    <div className={css.testimonialSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <h2>{intl.formatMessage({ id: 'SectionTestimonials.title' })}</h2>
        </div>

        <div className={css.testimonialSlider}>
          {testimonials.map((testimonial, index) => (
            <div className={css.testimonialBlock} key={testimonial.id || index}>
              <div className={css.testimonialCard}>
                <div className={css.stars}>
                  <ReviewRating className={css.ratings} rating={testimonial.rating} />
                </div>

                <blockquote className={css.testimonialBody}>
                  <p>“{testimonial.content}”</p>
                </blockquote>

                <div className={css.author}>
                  <h3>{testimonial.displayName}</h3>
                  <p>{testimonial.eventType}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SectionTestimonials;
